import { render, staticRenderFns } from "./StorageShippingUnitsDetail.vue?vue&type=template&id=64565a84&scoped=true&"
import script from "./StorageShippingUnitsDetail.vue?vue&type=script&lang=ts&"
export * from "./StorageShippingUnitsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64565a84",
  null
  
)

export default component.exports